<div class="zone id{{container.data.parameters.parameterId}} zone--parameters zones-container-tile"
     data-testid="zone-tile"
     *ngIf="container"
     (click)="views.isMobileView() && setTemplate()">
    <div class="zones-container-tile__top">
        <floating-subtitle class="zones-container-tile__top-name"
            [text]="container.data.containerName">
        </floating-subtitle>
        <div class="zone__status">
            <div class="gradient-zone zone__status-background"
                 data-testid="animation"
                 [ngClass]="{ 'zone__status--animated': container.data.parameters.freeContactState }"
                 *ngIf="container.data.parameters.hcState">
            </div>
            <div class="gradient-zone-cooling zone__status-background"
                 data-testid="animation"
                 [ngClass]="{ 'zone__status--animated': container.data.parameters.freeContactState }"
                 *ngIf="!container.data.parameters.hcState">
            </div>
        </div>
    </div>

    <div class="zones-container-tile__content-icon-wrapper">
        <img class="zones-container-tile__content-icon"
             *ngIf="container.data.iconId !== 0"
             ngSrc="/assets/img/id_icons/{{ container.data.iconId }}.svg"
             width="40" height="40" alt="" />
    </div>

    <div class="zones-container-tile__content">
        <floating-subtitle class="zones-container-tile__name"
            [text]="getTypeSubtitle()">
        </floating-subtitle>
    </div>

    <div class="zones-container-tile__footer bg-gradient bg-gradient--zone">
        <div class="zones-container-tile__footer-icons">
            <div class="zones-container-tile__footer-icons-wrapper"
                 [ngClass]="{ 'bg-cancel': container.data.parameters.signal === -3 }">
                <img class="zones-container-tile__icon zones-container-tile__icon--small"
                     data-testid="communication-icon"
                     *ngIf="container.data.parameters.signal >= 0 || container.data.parameters.signal === -2"
                     ngSrc="{{zones.signalIcon({signalStrength: container.data.parameters.signal}, 'white')}}"
                     width="25" height="25" alt="" />
                <img class="zones-container-tile__icon"
                     data-testid="communication-icon"
                     *ngIf="container.data.parameters.signal === -3"
                     ngSrc="/assets/img/id_icons/122.svg"
                     width="25" height="25" alt="" />
            </div>
            <div class="zones-container-tile__footer-icons-wrapper"
                 data-testid="algorithm-icon"
                 *ngIf="container.data.parameters.ecoInputState">
                <img class="zones-container-tile__icon zones-container-tile__icon zones-container-tile__icon--big"
                     ngSrc="/assets/img/id_icons/199-big.svg"
                     width="36" height="36" alt="" />
            </div>
            <div class="zones-container-tile__footer-icons-wrapper"
                 data-testid="algorithm-icon"
                 *ngIf="!container.data.parameters.ecoInputState">
                <img class="zones-container-tile__icon zones-container-tile__icon--small"
                     *ngIf="container.data.parameters.hcState"
                     ngSrc="/assets/img/zone_icons/sun_white.svg"
                     width="25" height="25" alt="" />
                <img class="zones-container-tile__icon zones-container-tile__icon--small"
                     *ngIf="!container.data.parameters.hcState"
                     ngSrc="/assets/img/zone_icons/snowflake_white.svg"
                     width="25" height="25" alt="" />
            </div>
            <div class="zones-container-tile__footer-icons-wrapper"
                [ngClass]="{ 'zones-container-tile__footer-icons-wrapper--active fill-icon--with-path klimor-fill-icon-white-with-path'
                    : container.data.parameters.pumpsState}">
                <icon [iconName]="'17'"
                      data-testid="pump-icon"
                      [iconSize]="views.isMobileView() ? 25 : 36"
                      [className]="'zones-container-tile__icon'">
                </icon>
            </div>
            <div class="zones-container-tile__footer-icons-wrapper zones-container-tile__footer-icons-wrapper--no-border"
                 [ngClass]="{
					'zones-container-tile__footer-icons-wrapper--active fill-icon fill-icon--white'
					    : container.data.parameters.freeContactState,
					'zones-container-tile__footer-icons-wrapper--separator'
					    : container.data.parameters.pumpsState && container.data.parameters.freeContactState
				}">
                <icon [iconName]="'relay'"
                        data-testid="relay-icon"
                      [iconSize]="views.isMobileView() ? 25 : 36"
                      [className]="'zones-container-tile__icon'">
                </icon>
            </div>
        </div>
        <div class="zone__settings bg-input bg-input--primary cursor-pointer zones-container-tile__icon--settings"
            (click)="zones.showHideDropdownList(container.data.parameters.parameterId, 'container-tile')"
            [ngClass]="{ 'bg-input--open': container.data.parameters.parameterId === zones.containerTileDropdown.id,
                'bg-input--primary': !(container.data.parameters.parameterId === zones.containerTileDropdown.id)}"
            title="{{subtitle(2972)}}">
            <icon [iconName]="'settings'"
                  data-testid="settings-icon"
                  [iconSize]="40"
                  [className]="'fill-icon fill-icon--white'">
            </icon>
        </div>
    </div>

    <div class="dropdown-list dropdown-list--grey"
         *ngIf="container.data.parameters.parameterId === zones.containerTileDropdown.id
            && zones.containerTileDropdown.show"
         (click)="zones.showHideDropdownList(0)"
         [ngStyle]="{'bottom': zones.containerTileDropdown.position.bottom,
            'top' : zones.containerTileDropdown.position.top}">
        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{subtitle(8309)}}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                     data-testid="parameter-communication-icon"
                     *ngIf="container.data.parameters.signal !== -3
                        && container.data.parameters.signal !== -1"
                     ngSrc="{{zones.signalIcon({signalStrength: container.data.parameters.signal})}}"
                     width="19" height="16" alt="" />
                <div *ngIf="container.data.parameters.signal === -3"
                     class="dropdown-list__value dropdown-list__value--wide color-alarm">
                    <div>{{subtitle(4282)}}</div>
                    <div class="dropdown-list__value--single">{{subtitle(1808)}}</div>
                </div>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold"
             *ngIf="container.data.parameters.hasOwnProperty('ecoInputConnection')">
            <p class="dropdown-list__item-name">{{subtitle(12740)}}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                   {{subtitle(container.data.parameters.ecoInputState ? 5829 : 5830)}}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(814) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                   {{ subtitle(container.data.parameters.hcState ? 1816 : 1815) }}</p>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(3089)}}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                   {{ subtitle(container.data.parameters.pumpsState ? 2792 : 2618)}}</p>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(1736) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                   {{ subtitle(container.data.parameters.freeContactState ? 5829 : 5830) }}</p>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{subtitle(1634)}}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">{{ container.data.version}}</p>
            </div>
        </div>

        <div class="dropdown-list__item font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(8490) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">{{ container.data.processorId }}</p>
            </div>
        </div>

        <div class="dropdown-list__item dropdown-list__item--higher dropdown-list__item--table font-12 font-bold"
             data-testid="connection-table"
             *ngFor="let connection of container.data.connections; let idx = index">
             <connection-table
                [container]="container"
                [chunk]="idx"
              ></connection-table>
        </div>

        <div class="dropdown-list__item dropdown-list__item--higher font-12 font-bold"
             *ngIf="container.data.wikiId !== 0">
            <p class="dropdown-list__item-name">{{subtitle(1107)}}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">{{ subtitle(container.data.wikiId)}}</p>
            </div>
        </div>
    </div>
</div>
